<!--
 * @Description: 跟进记录编辑
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-05-31 17:58:57
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :permissionPage="permissionBasic" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import baseMessage from '../components/baseMessage.vue'
const permissionBasic = {
  save: 'ofbu_follow_edit_btn'
}
</script>
<script lang="ts">
export default {
  name: 'DcCosOFbuFollowUpRecordEdit'
}
</script>
